import { ResponseRequest, ResponseRequestGeneric } from "Types/GeneralTypes";
import axios from "axios";
import configData from "config.json"
import { authHeader, authHeaderWithToken } from "helpers/auth-header";
import { handle_error_axios } from "helpers/fetchErrors";
import { HistorialFirmaAvisoEntrada, PersonalFirmaAvisoEntrada } from "./TypesFirmaAvisoEntrada";
import { hadleAxiosError, hadleAxiosErrorResponse } from "helpers/handle-response";
import { ObjetoSubirDocumento } from "../../Varios/Modals/ModalSubirDocumentoFirmado";
import { alertService } from "../../Varios/alert_service";

const URL_GETPERSONAL_PENDIENTE_FIRMA = "SolicitudIngreso/PersonalFirmaAvisoEntrada";
const URL_HISTORIAL_FIRMA = "SolicitudIngreso/HistorialAvisoEntrada";
export const URL_ANIOS_HISTORIAL_FIRMA = "SolicitudIngreso/YearsHistorialFirmaAvisoEntrada";
export const URL_REPORTE_HISTORIAL_FIRMA = "SolicitudIngreso/ReporteHistorialAvisoEntrada";
const URL_RECHAZAR_DOCUMENTO_AVISO_ENTRADA_SERVIDOR = "SolicitudIngreso/RechazarAvisoEntradaServidor"

export async function ObtenerPersonalFirmaDocumentoPazSalvo() {
    var respuesta: ResponseRequestGeneric<PersonalFirmaAvisoEntrada[]> = {
        status: -1,
    }

    try {
        const respuestaPersonal = await axios.get(configData.SERVER_URL + URL_GETPERSONAL_PENDIENTE_FIRMA, {
            headers: authHeader()
        })
        respuesta.status = respuestaPersonal.status;
        respuesta.dataResponse = respuestaPersonal.data;
    } catch (error) {
        respuesta = await hadleAxiosErrorResponse(error);
    }

    return respuesta;
}

export async function HandleSubirDocumentoAvisoEntrada(objeto: ObjetoSubirDocumento) {

    const { filesEnviar, tipoFirma, extraData } = objeto;

    if (filesEnviar.length > 0) {
        var formFilesData = new FormData();

        try {
            filesEnviar.map((fileData) => {
                formFilesData.append("files", fileData.file, fileData.file.name);
            })

            formFilesData.append('idOtrosDocumentos', extraData.idOtrosDocumentos);
            formFilesData.append('tipoDocumento', extraData.tipoDoc);
            formFilesData.append('tipoFirma', tipoFirma);
            formFilesData.append('etapa', "FINANCIERO");

            const URL = configData.SERVER_URL + "FormularioController/PostFileDocumentoAvisoEntrada"
            const respuesta = await axios.post(URL, formFilesData, {
                headers: authHeader()
            })

            alertService.success("Se ha guardado con éxito")
            return 1
        } catch (error) {
            const mensajeError = hadleAxiosError(error);
            alertService.error(mensajeError);
            return -1
        }
    }

    return -1
}

export async function ObtenerHistorialFirmaDocumentoPazSalvo(anio: number) {
    var respuesta: ResponseRequestGeneric<HistorialFirmaAvisoEntrada[]> = {
        status: -1,
    }

    try {
        const respuestaHistorial = await axios.get(configData.SERVER_URL + URL_HISTORIAL_FIRMA + "/" + anio, {
            headers: authHeader()
        })
        respuesta.status = respuestaHistorial.status;
        respuesta.dataResponse = respuestaHistorial.data;

    } catch (error) {
        respuesta = await hadleAxiosErrorResponse(error);
    }

    return respuesta;
}

export async function ObtenerYearsHistorialFirmaDocumentoPazSalvo() {
    var respuesta: ResponseRequestGeneric<number[]> = {
        status: -1,
    }

    try {
        const respuestaHistorial = await axios.get(configData.SERVER_URL + URL_ANIOS_HISTORIAL_FIRMA, {
            headers: authHeader()
        })
        respuesta.status = respuestaHistorial.status;
        respuesta.dataResponse = respuestaHistorial.data;

    } catch (error) {
        respuesta = await hadleAxiosErrorResponse(error);
    }

    return respuesta;
}

export async function RechazarAvisoEntradaServidor(idOtrosDocumentos: number, observacion: string) {

    var respuesta: ResponseRequest = {
        status: -1,
    }

    const postNegarAvisoSalida = {
        idOtrosDocumentos: idOtrosDocumentos,
        descripcion: observacion
    }

    try {
        const URL_COMPLETA = `${configData.SERVER_URL + URL_RECHAZAR_DOCUMENTO_AVISO_ENTRADA_SERVIDOR}`;
        const respuestaHistorial = await axios.put(URL_COMPLETA, postNegarAvisoSalida, {
            headers: authHeader()
        })
        respuesta.status = respuestaHistorial.status;
    } catch (error) {
        respuesta = await hadleAxiosErrorResponse<void>(error)
    }

    return respuesta;
}